import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
export default {
  name: "LocationMap",
  components: {
    LMap: LMap,
    LTileLayer: LTileLayer,
    LMarker: LMarker
  },
  data: function data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: this.isPreview ? 14 : 12,
      center: this.coordinates || [36.3253812, 59.5554734],
      centerLatLong: this.coordinates || [36.3253812, 59.5554734],
      polygon: {
        latlngs: [],
        color: "green"
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.isPreview) {
      this.$refs.map.mapObject.on("move", function () {
        var latLong = _this.$refs.map.mapObject.getCenter();

        _this.centerLatLong = [latLong.lat, latLong.lng];
      });
    }
  },
  watch: {
    coordinates: function coordinates(newCoordinates) {
      this.center = newCoordinates;
      this.centerLatLong = newCoordinates;
    }
  },
  methods: {
    submitLocation: function submitLocation() {
      this.$emit("selectLocation", this.centerLatLong);
    }
  },
  props: {
    polygonClicked: {
      required: false,
      type: Function
    },
    mapStyle: {
      required: false,
      type: String
    },
    isPreview: {
      required: false,
      type: Boolean
    },
    coordinates: {
      required: false,
      type: Array
    }
  }
};